import { envUrl } from '../../env-url'
import { isSecureLink } from '@/utils'

export default {
  styles: [
    '/themes/ordriket/css/ordriket.css',
    'https://use.typekit.net/ebk2fpx.css',
    'https://fonts.googleapis.com/css2?family=Lato:wght@300;400;700&display=swap',
    '/common/primary/icons-primary.css',
  ],
  gtm: 'GTM-KPJW89H',
  levels: [
    {
      level: 1,
      url: `${isSecureLink()}://ordriket1${envUrl()}`,
    },
    {
      level: 2,
      url: `${isSecureLink()}://ordriket2${envUrl()}`,
    },
    {
      level: 3,
      url: `${isSecureLink()}://ordriket3${envUrl()}`,
    },
    {
      level: 4,
      url: `${isSecureLink()}://ordriket4${envUrl()}`,
    },
    {
      level: 5,
      url: `${isSecureLink()}://ordriket5${envUrl()}`,
    },
    {
      level: 6,
      url: `${isSecureLink()}://ordriket6${envUrl()}`,
    },
    {
      level: 7,
      url: `${isSecureLink()}://ordriket7${envUrl()}`,
    },
  ],
  beta: 'https://app.bwz.se/vigmostad/b/v?survey=104&ucrc=EF8A495CFF',
  dbokLink: 'https://app.bwz.se/vigmostad/b/v?survey=267&ucrc=5A52386BE1',
  hasRoleSwitch: true,
  layout: {
    nav: 'NavPrimary',
    overview: 'OverviewPrimary',
    unit: 'UnitPrimary',
    exercise: 'ExerciseV1',
    lesson: 'LessonPrimary',
  },
  text: {
    nb: {
      LANDING: {
        TEXT_TOPBAR:
          'Dette er nettressursen til Ordriket 2. utgave (LK20). Nettressurs for 1. utgave finner du <a class="v-landing__topbar-link" href="https://ordriket2013.portfolio.no/" target="_blank">her</a>.',
      },
    },
    nn: {
      LANDING: {
        TEXT_TOPBAR:
          'Dette er nettressursen til Ordriket 2. utgave (LK20). Nettressurs for 1. utgave finner du <a class="v-landing__topbar-link" href="https://ordriket2013.portfolio.no/" target="_blank">her</a>.',
      },
    },
  },
}
